import {convertKeyToLabel} from '../TableUtils'

export const importTypes = {
    patient: 'Patient',
    userLog: 'User-Log',
    generalPractitioner: 'General-Practitioner',
}

// export const settingFileDataList = [
//     {
//         key: 'File Import Information',
//         description: (
//             <div>
//                 <p className="mb-2">
//                     Fill in the following information to import file
//                 </p>
//             </div>
//         ),
//         children: [
//             {
//                 key: 'client',
//                 component: component.dropdown,
//                 placeholder: 'Input your client',
//             },
//             {
//                 key: 'Hospital',
//                 component: component.dropdown,
//                 placeholder: 'Input your hospital',
//             },
//             {
//                 key: 'authorHCPName',
//                 component: component.inputText,
//                 placeholder: 'Input your fullname to import patient',
//             },
//         ],
//     },
// ]

export const stepKeys = [
    {
        label: 'Prepare Your Data File',
    },
    {
        label: 'Upload File',
    },
    {
        label: 'Completion',
    },
]
export const gpImportHeader = [
    {
        key: 'name',
        label: 'Name',
    },
    {
        key: 'email',
        label: convertKeyToLabel('email'),
    },
    {
        key: 'surgery',
        label: convertKeyToLabel('surgery'),
    },
]
export const patientImportHeader = [
    {
        field: 'username',
        header: 'Username',
    },
    {
        field: 'email',
        header: 'Email',
    },
    {
        field: 'firstName',
        header: 'First Name',
    },
    {
        field: 'lastName',
        header: 'Last Name',
    },
    {
        field: 'nhsNumber',
        header: 'NHS Number',
    },
    {
        field: 'dob',
        header: 'Date of Birth',
    },
    {
        field: 'title',
        header: 'Title',
    },
    {
        field: 'gender',
        header: 'Gender',
    },
    {
        field: 'currentLocation',
        header: 'Current Location',
    },
    {
        field: 'occupation',
        header: 'Occupation',
    },
    {
        field: 'maritalStatus',
        header: 'Marital Status',
    },
    {
        field: 'religion',
        header: 'Religion',
    },
    {
        field: 'accommodationStatus',
        header: 'Accommodation Status',
    },
    {
        field: 'identityWithHeldReason',
        header: 'Identity With Held Reason',
    },
    {
        field: 'diagnostic',
        header: 'Diagnostic',
    },
    {
        field: 'country',
        header: 'Country',
    },
    {
        field: 'state',
        header: 'State',
    },
    {
        field: 'city',
        header: 'City',
    },
    {
        field: 'addressLine1',
        header: 'Address Line 1',
    },
    {
        field: 'addressLine2',
        header: 'Address Line 2',
    },
    {
        field: 'addressLine3',
        header: 'Address Line 3',
    },
    {
        field: 'addressLine4',
        header: 'Address Line 4',
    },
    {
        field: 'postalCode',
        header: 'Postal Code',
    },
    {
        field: 'phone',
        header: 'Phone',
    },
]

export const userLogImportHeader = [
    {
        key: 'firstName',
        label: 'First Name',
    },
    {
        key: 'lastName',
        label: 'Last Name',
    },
    {
        key: 'email',
        label: 'Email',
    },
    {
        key: 'username',
        label: 'Username',
    },
    {
        key: 'nhsNumber',
        label: 'Nhs Number',
    },
    {
        key: 'dob',
        label: 'Dob',
    },
    {
        key: 'genderValue',
        label: 'Gender',
    },
    {
        key: 'occupation',
        label: 'Occupation',
    },
    {
        key: 'identityWithHeldReasonValue',
        label: 'Identity With Held Reason Value',
    },
    {
        key: 'maritalStatusValue',
        label: 'Marital Status Value',
    },
    {
        key: 'religionValue',
        label: 'Religion Value',
    },
    {
        key: 'accommodationStatusValue',
        label: 'Accommodation Status Value',
    },
    {
        key: 'diagnosticValue',
        label: 'Diagnostic Value',
    },
    {
        key: 'active',
        label: 'Active',
    },
    {
        key: 'address',
        label: 'Address',
    },
    {
        key: 'createdAt',
        label: 'Created At',
    },
    {
        key: 'modifiedBy',
        label: 'Modified By',
    },
]
